import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiForm, apiJson } from "@/data/api";
import { authKeys } from "@/data/auth";

export function updateMyProfile(input: { fullName: string }) {
  return apiJson<void>("/auth/me/profile", {
    method: "PATCH",
    json: { full_name: input.fullName },
  });
}

export function uploadMyAvatar(file: File) {
  const form = new FormData();
  form.append("file", file);
  return apiForm<{ url: string }>("/auth/me/avatar", form);
}

export function useUpdateMyProfileMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMyProfile,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: authKeys.session() });
    },
  });
}

export function useUploadMyAvatarMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: uploadMyAvatar,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: authKeys.session() });
    },
  });
}
